import { Injectable,  } from '@angular/core';
import { read, IWorkBook, IWorkSheet} from 'ts-xlsx';
import { Observable } from 'rxjs/Rx';
 
@Injectable()
export class ExcelService {
    constructor() {}

    readFile(file:File):Observable<any>{
        return new Observable<any>((observer) => {
            let reader: FileReader = new FileReader();
            reader.onload = (e) => {
                observer.next((e.target as any).result);
            };
            reader.readAsBinaryString(file);
            return () => {
                reader.abort();
            };
        }).map((value: string) => {
            return read(value, {type: 'binary'});
        }).map((wb: IWorkBook) => {
            return {result: 'success', wb}
            // return wb.SheetNames.map((sheetName: string) => {
            //     let sheet: IWorkSheet = wb.Sheets[sheetName];
            //     console.log(sheet);
            //     return {result: 'success', sheet};
            // });
        })
        // .map((results: Array<any>) => {
        //     console.log("results", results);
        //     return {result: 'success', payload: results};
        // })
        .catch(e => Observable.of({result: 'failure', payload: e}));
    }

}


// WEBPACK FOOTER //
// ./src/app/services/excel.service.ts